
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Eine Migräne kann manchmal länger dauern, als die Wirkung des Schmerzmedikaments anhält. Sobald diese nachlässt, kehren die Schmerzen wieder. Bei den sogenannten Triptanen zum Beispiel tritt dieses Phänomen in 15 bis 40 Prozent der Fälle auf.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;